module.exports = __webpack_public_path__ + "img/IgniteADX.fbdf5a05.png";